jQuery(document).ready(function($) {

  // Recherche en cliquant sur une thématique
	$("form#rechercher-ressources").submit(function(e){
    e.preventDefault();
		var count = -1;
    	updateQueryWithThematique(count);
	});

	$("form#rechercher-ressources .effacer").click(function(e){
    e.preventDefault();
		$("#recherche").val('');
		$("#niveau").val($("#niveau option:first").val());
		var count = -1;
    	updateQueryWithThematique(count);
	});

  // Fonction de mise à jour de la requête des ressources pour afficher les résultats
	function updateQueryWithThematique(count){

	    var district = $('#niveau').val();
	    var recherche = $('#recherche').val();
	    var post_type = $('#post_type').val();
	    var localisation = $('#localisation').val();

		$('.ressources-result-container').addClass('loading');
		jQuery.ajax( {
			url : ajax_object.ajax_url,
			type: 'POST',
			data: {
				action  : 'ajax_update_ressources_loop',
				'post_type_arg': post_type,
				'district_arg': district,
				'recherche_arg': recherche,
				'count': count,
				'localisation': localisation,
			},
		} )
		.success( function( results ) {
	    	$('#ressources-result').html(results);
	    	$('.ressources-result-container').removeClass('loading');
		} )
		.fail( function( data ) {
			console.log( data.responseText );
			console.log( 'Request failed: ' + data.statusText );
			$('.ressources-result-container').removeClass('loading');
		});
	}


});
